<template>
  <section
    :class="{
      'pull-quote': true,
    }"
  >
    <HorizontalLine />
    <div
      :class="{
        'mx-auto block max-w-[50rem] text-[22px] font-bold italic leading-6 text-www-color-primary-light': true,
      }"
    >
      <slot />
    </div>
    <HorizontalLine />
  </section>
</template>

<script lang="ts" setup>
import HorizontalLine from '../HorizontalLine/HorizontalLine.vue';
</script>

<style></style>
